const geracao_estimativa_de_matricula_com_reordenamento_contraturno = {
  path: "/geracao-estimativa-de-matricula-com-reordenamento-contraturno",
  redirect: "/geracao-estimativa-de-matricula-com-reordenamento-contraturno",
  meta: {
    breadCrumb:
      "Planejamento de Matrícula - Gerar Estimativa de Matrícula com Reordenamento Contraturno",
  },
  children: [
    {
      path: "/geracao-estimativa-de-matricula-com-reordenamento-contraturno",
      name: "geracao-estimativa-de-matricula-com-reordenamento-contraturno",
      component: () =>
        import(
          "@/views/GeracaoEstimativaDeMatriculaComReordenamentoContraturno/GeracaoEstimativaDeMatriculaComReordenamentoContraturnoHome.vue"
        ),
    },
  ],
};

export { geracao_estimativa_de_matricula_com_reordenamento_contraturno };
